import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import {
  DocumentoAllegatoAdapter
} from '../../components/documenti/documento-update-metadati/documento-allegato-adapter';
import { DocumentoAllegato } from '../../models/documento-allegato';


import { Provenienza } from '../../models/tipologiche/provenienza';
import { TipoDocumento } from '../../models/tipologiche/tipo-documento';
import { BaseForm } from '../base-Form';
import { VisibilitaDocumento } from '../../models/tipologiche/visibilita-documento';
import { DocumentoScansionato, questionsBasic } from './document-uploaded/campi';
import { FormFieldBase } from '../../components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { TipoTipologica } from '../../models/tipologiche/tipo-tipologica';


export abstract class DocumentUpdateMetadatiFormAbstractComponent extends BaseForm {
  request: DocumentoAllegatoAdapter;
  requestAdapter: DocumentoAllegatoAdapter;
  modificaDocumentoForm: FormGroup;
  tipiProvenienza: Provenienza[];
  tipiDocumento: TipoDocumento[];
  tipoSezione: string;
  isCensimentoDocumenti: boolean = false;
  tipiVisibilitaDocumento: VisibilitaDocumento[];
  dynamicFields: FormFieldBase[] = [];
  documentiScansionati:any = [];
  documentiScansionatiTemp:any = [];

  constructor(
    protected operationService: OperationsService, 
    private campiForm: FormBuilder, 
    private helpers: HelpersService,
    private fb: FormBuilder
  ) {
    super();
  }

  initRequest(documento) {

    this.requestAdapter = new DocumentoAllegatoAdapter(documento);
    this.request = new DocumentoAllegatoAdapter(documento);
    this.getTipiProvenienza();
    this.getTipiDocumento();
    this.getTipiVisibilitaDocumento();
  }

  createForm(documento, esn?: string) {
    this.documentiScansionatiTemp = [];
    this.tipoSezione = esn;
    this.initRequest(documento);

    const metadato = this.request.documento?.metadatoDocumento;

    const campiBackend: string[] = metadato
      ? Object.keys(metadato)
      : [];

    this.dynamicFields = questionsBasic(campiBackend, []).map(f => ({
      ...f,
      controlType: f.controlType?.toLowerCase()
    }));

    this.documentiScansionati = [...metadato.documentiScansionati];
    this.modificaDocumentoForm = this.campiForm.group({
      titolo: [this.request.documento.titolo, Validators.required],
      note: [this.request.documento.note],
      tipoDocumento: [this.request.documento.tipoDocumento, Validators.required],
      provenienza: [this.request.documento.provenienza, Validators.required],
      dataRiferimento: [this.request.documento.dataRiferimento, Validators.required],
      oggettoProtocolloEsteso: [this.request.documento.oggettoProtocolloEsteso],
      tipoVisibilitaDocumento: [this.request.documento.tipoVisibilitaDocumento, Validators.required],
      estremiProvvedimento: [this.request.documento.estremiProvvedimento],
      dataAnnullamento: [this.request.documento.dataAnnullamento],
      // detail: this.fb.array(this.documentiScansionati)
    });
    if (this.request.documento.statoDocumento === 'ANNULLATO' && this.request?.documento?.flagAllegatoPrincipale) {
      this.modificaDocumentoForm.get('estremiProvvedimento').setValidators([Validators.required]);
      this.modificaDocumentoForm.get('dataAnnullamento').setValidators([Validators.required]);
    } else {
      this.modificaDocumentoForm.get('estremiProvvedimento').clearValidators();
      this.modificaDocumentoForm.get('dataAnnullamento').clearValidators();
    }
    this.modificaDocumentoForm.get('estremiProvvedimento').updateValueAndValidity();
    this.modificaDocumentoForm.get('dataAnnullamento').updateValueAndValidity();
    this.dynamicFields.forEach(field => {
      let value = this.request.documento.metadatoDocumento[field.key];

        if (field.key === 'documentoUnico') {
          value = value ? 'Sì' : 'No'; // <-- mappo boolean su radio
        } else if (value && typeof value === 'object' && 'id' in value) {
          value = value.id;
        }

        this.modificaDocumentoForm.addControl(
          field.key,
          new FormControl(
            value ?? null,
            field.required ? Validators.required : null
          )
        );
      });
      if(this.request.documento.statoDocumento === 'FIRMATO'){
        const modalitaCtrl = this.modificaDocumentoForm.get('modalitaFormazioneDocumento');
        const produttoreCtrl = this.modificaDocumentoForm.get('tipoUfficioProduttore');
        const index = this.dynamicFields.findIndex(f => f.key === 'motivoAssenzaFirma');
        if (index > -1) this.dynamicFields.splice(index, 1);
        this.modificaDocumentoForm.removeControl('motivoAssenzaFirma');
        
        if (modalitaCtrl && produttoreCtrl?.value === 'INTERNO') {
          modalitaCtrl.disable({ emitEvent: false });
        }else {
          modalitaCtrl.enable({ emitEvent: false });
        }
        this.detectTipoUfficioProduttoreChanges();
      }
    this.handleDependentFields();
    this.detectDocumentoUnicoChanges();
    this.detectNumScansioneChanges();
  }

  onDetaillengthChange(length:number) {
    this.modificaDocumentoForm.controls["numDocumentiScansione"].setValue(length, { emitEvent: false });
    // this.payload["numDocumentiScansione"] = length;
  }

  onDetailChange(event: DocumentoScansionato[]) {
    this.documentiScansionatiTemp = event;
    // this.request.documento.metadatoDocumento.documentiScansionati = event;
  }

  getTipiProvenienza() {
    if(!!this.isCensimentoDocumenti) {
      this.helpers.getTipiProvenienzaDocumento().subscribe(response => this.tipiProvenienza = (<Provenienza[]>response));
    } else {
      this.helpers.getTipiProvenienzaDocumento().subscribe(response => this.tipiProvenienza = (<Provenienza[]>response));
    }
  }


  getTipiDocumento() {
    this.helpers.getTipiDocumenti().subscribe(response => this.tipiDocumento = response && response.length>0 ? (response.sort((a, b)=>(a.label < b.label ) ? -1 : 1)) : []);
  }

  getTipiVisibilitaDocumento(){
    this.helpers.getTipiVisibilitaDocumento().subscribe(response => this.tipiVisibilitaDocumento = response);
  }

  update() {
    console.log(this.modificaDocumentoForm.getRawValue(), "modificaDocumentoForm")
    this.dynamicFields.forEach(field => {
      let value = this.modificaDocumentoForm.get(field.key)?.value;

      if (field.key === 'documentoUnico') {
        value = value === 'Sì';
      } else if (this.request.documento.metadatoDocumento[field.key] 
                && typeof this.request.documento.metadatoDocumento[field.key] === 'object') {
        value = { ...this.request.documento.metadatoDocumento[field.key], id: value };
      }

      this.request.documento.metadatoDocumento[field.key] = value;
    });
    const formValue = this.modificaDocumentoForm.value;
    // Aggiorno i campi annullamento SOLO se il documento è annullato
    if (this.request.documento.statoDocumento === 'ANNULLATO') {
      this.request.documento.estremiProvvedimento = formValue.estremiProvvedimento;
      this.request.documento.dataAnnullamento = formValue.dataAnnullamento;
    }const payload = {
      ...this.request,
      documento: {
        ...this.request.documento,
        metadatoDocumento: {
          ...this.request.documento.metadatoDocumento,
          documentiScansionati: this.documentiScansionatiTemp
        }
      }
    };
    payload.documento.metadatoDocumento.documentiScansionati = this.documentiScansionatiTemp;
    console.log('payload AGGIORNATO:', payload.documento);
    if(typeof payload.documento.metadatoDocumento.tipoUfficioProduttore === 'string') {
      let tipoProduttore = this.mapToTipoTipologica(payload.documento.metadatoDocumento.tipoUfficioProduttore);
      payload.documento.metadatoDocumento.tipoUfficioProduttore = tipoProduttore;
    }
    this.saveOperation(payload.documento);
  }

  getNameFile(nameFile) {
    return nameFile.split(this.getSeparatorePathLogico()).slice(-1)[0];
  }

  private handleDependentFields() {
    const docUnicoCtrl = this.modificaDocumentoForm.get('documentoUnico');
    if (!docUnicoCtrl) return;

    const isNo = docUnicoCtrl.value?.toLowerCase() === 'no'; // <-- stringa "Sì"/"No"
    if (isNo) {
      if (!this.modificaDocumentoForm.get('numDocumentiScansione')) {
        this.modificaDocumentoForm.addControl(
          'numDocumentiScansione',
          new FormControl(
            this.request.documento.metadatoDocumento['numDocumentiScansione'] ?? 0
          )
        );

        this.dynamicFields.push({
          key: 'numDocumentiScansione',
          label: 'Numero copie scansione',
          controlType: 'number',
          size: 'col-sm-5',
          required: false,
          chips: false,
          options: null,
          disabled: false
        });
      }
    }
  }


  private detectDocumentoUnicoChanges() {
    const docUnicoCtrl = this.modificaDocumentoForm.get('documentoUnico');
    if (!docUnicoCtrl) return;

    docUnicoCtrl.valueChanges.subscribe(value => {
      const isNo = value?.toLowerCase() === 'no';

      if (isNo) {
        // aggiungo il campo solo se non esiste già
        if (!this.modificaDocumentoForm.get('numDocumentiScansione')) {
          this.modificaDocumentoForm.addControl(
            'numDocumentiScansione',
            new FormControl(this.request.documento.metadatoDocumento['numDocumentiScansione'] ?? 0)
          );

          this.dynamicFields.push({
            key: 'numDocumentiScansione',
            label: 'Numero copie scansione',
            controlType: 'number',
            size: 'col-sm-5',
            required: false,
            chips: false,
            options: null,
            disabled: false
          });
          this.detectNumScansioneChanges();
        }
      } else {
        this.documentiScansionatiTemp = [];
        this.documentiScansionati = [];
        this.request.documento.metadatoDocumento.documentiScansionati = [];
        this.request.documento.metadatoDocumento.numDocumentiScansione = 0;
        // rimuovo il campo solo se esiste
        const index = this.dynamicFields.findIndex(f => f.key === 'numDocumentiScansione');
        if (index > -1) this.dynamicFields.splice(index, 1);

        if (this.modificaDocumentoForm.get('numDocumentiScansione')) {
          this.modificaDocumentoForm.removeControl('numDocumentiScansione');
        }
      }
    });
  }

  private detectTipoUfficioProduttoreChanges(){
     const produttoreCtrl = this.modificaDocumentoForm.get('tipoUfficioProduttore');
     const modalitaCtrl = this.modificaDocumentoForm.get('modalitaFormazioneDocumento');
     produttoreCtrl?.valueChanges.subscribe(value => {
      if (value === 'INTERNO') {
        modalitaCtrl.setValue('A', { emitEvent: false });
        modalitaCtrl.disable({ emitEvent: false });
      } else {
        modalitaCtrl.setValue('B', { emitEvent: false });
        modalitaCtrl.enable({ emitEvent: false });
      }
    });
  }


  private detectNumScansioneChanges() {
    const numDocumentiScansione = this.modificaDocumentoForm.get('numDocumentiScansione');
    if (!numDocumentiScansione) return;

    numDocumentiScansione.valueChanges.subscribe(value => {
      const currentLength = this.documentiScansionati.length;

      if (value > currentLength) {
        // aggiungi elementi vuoti fino a raggiungere 'value'
        const array = Array.from({ length: value - currentLength }, () => ({
          titolo: "",
          produttore: "",
          firmatari: ""
        }));
        this.documentiScansionati = [...this.documentiScansionati, ...array];
      } else if (value < currentLength) {
        // taglia l'array ai primi 'value' elementi
        this.documentiScansionati = this.documentiScansionati.slice(0, value);
      }
      // se value === currentLength non fare nulla
    });
  }

  mapToTipoTipologica = (key?: string): TipoTipologica | undefined => {
    if (!key) return undefined;
    return { id: key, descrizione: '', label: '', rimosso: false };
  };



  abstract saveOperation(request: DocumentoAllegato);
  abstract getSeparatorePathLogico();

}
